import React from 'react';
import { TheFooter, TheHeader } from './index';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { LOGOUT_TIMEOUT } from '../utils/userUtils';

const ErrorPage = React.lazy(() => import('../views/err/errorPage'));

const TheErrorLayout = (props) => {
  const dispatch = useDispatch();

  dispatch({ type: 'set', cognitoUser: props.auth.user });

  const logout_timerid = useSelector((state) => state.logoutTimerId);
  const history = useHistory();

  const isAuthenticated = () => {
    return props.auth.isAuthenticated && props.auth.user;
  };

  const logout = () => {
    history.push({
      pathname: '/logout',
    });
  };

  // タイマー処理を更新（破棄・再予約）する
  const updateTimer = () => {
    if (!isAuthenticated()) {
      return;
    }

    // 既存のタイマーをクリア
    clearTimeout(logout_timerid);
    // console.log("clear timer. id=" + logout_timerid);
    // タイマーを再予約
    const id = setTimeout(logout, LOGOUT_TIMEOUT);
    // 保存
    dispatch({ type: 'set', logoutTimerId: id });
  };

  return (
    <div
      className="c-app c-default-layout"
      onClick={updateTimer}
      onTouchStart={updateTimer}
      onTouchMove={updateTimer}
      onTouchEnd={updateTimer}
    >
      <div className="c-wrapper">
        <TheHeader />
        <div className="c-body">
          <main className="c-main">
            <ErrorPage />
          </main>
        </div>
        <TheFooter />
      </div>
    </div>
  );
};

export default TheErrorLayout;
